import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import './ForgotPassword.css';
import { BASE_URL } from '../constants';
import { api } from '../utils';
import { LOGIN_RESPONSES } from '../constants';

type Props = {
  showLogin: Function;
  email: string | boolean;
  showWarningForFailedLoginAttempt: Function;
  handleCloseModal: Function;
};
const Forgotpassword = ({
  showLogin,
  email,
  showWarningForFailedLoginAttempt,
  handleCloseModal,
}: Props) => {
  const emailRef = useRef<HTMLInputElement>(null);
  const [showResendLink, setShowResendLink] = useState(false);
  const [userEmail, setUserEmail] = useState(email);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [sendingMail, setSendingMail] = useState(false);

  useEffect(() => {
    prefillEmail();
  }, []);

  const handleErrors = (response: any) => {
    if (response.status === 401) {
      console.log(success);
      setError(true);
      setErrorMessage('you are not authorised');
      setSuccess(false);
      setSendingMail(false);
      throw Error(response.statusText);
    }
    return response;
  };
  const prefillEmail = () => {
    try {
      const search = window.location.search;

      const email = search.split('?email=')[1];

      if (typeof email === 'string' && email.trim().length) {
        const emailFormat = new RegExp(/(.+)@(.+)\.(.+)/).test(email);
        if (emailFormat) {
          setUserEmail(email.trim());
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const sendForgotPasswordLink = (e: Event) => {
    e.preventDefault();
    const username = emailRef && emailRef.current && emailRef.current.value;

    if (typeof username === 'string' && username.trim().length) {
      const emailFormat = new RegExp(/(.+)@(.+)\.(.+)/).test(username);
      setError(false);
      setErrorMessage('');
      if (emailFormat) {
        let data = new Object();
        data = {
          userEmail: username,
        };
        setSendingMail(true);

        api('ForgotPassword', 'POST', {
          userEmail: userEmail,
        })
          .then((res) => {
            setSendingMail(false);
            if (res.response !== null) {
              // if (res.status === 401) {
              //   showWarningForFailedLoginAttempt('Notice', res.response, [
              //     { title: 'Okay', theme: '3', onClick: handleCloseModal },
              //   ]);
              // } else {
              setError(false);
              setSuccess(true);
              setShowResendLink(true);
              // }
            } else {
              setError(true);
              setErrorMessage(LOGIN_RESPONSES.NOACCOUNT_EXIST);
            }
          })
          .catch((error) => {
            setSendingMail(false);
            console.log(error);
          });
      } else {
        setError(true);
        setErrorMessage(LOGIN_RESPONSES.IncorrectMail);
      }
    }
  };

  const checkLoginEnter = (e: any) => {
    if (e.key === 'Enter') {
      sendForgotPasswordLink(e);
    }
  };

  const changeState = () => {
    setShowResendLink(false);
  };
  const updateEmail = () => {
    const email: any = emailRef && emailRef.current && emailRef.current.value;
    setUserEmail(email);
  };
  const resendLinkView = () => {
    return (
      <div className='form-container'>
        <div className='welcome-text' style={{ whiteSpace: 'nowrap' }}>
          Check your <br /> e-mail
        </div>
        {/* <div className='welcome-text fp-header'> */}
        <div className='fp-header'>
          We have sent you a reset link to the e-mail address mentioned
        </div>
        <div className='resend-button'>
          <div style={{ position: 'relative', padding: '1.25rem', width: '94%' }}>
            <input
              type='submit'
              className={`btn btn-primary btn-block sf-login-btn sf-resend-link-btn`}
              value='Resend Link'
              onClick={changeState}
            />
            <div className='fp-links'>
              <span onClick={() => showLogin()}>Back to sign in</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {showResendLink ? (
        resendLinkView()
      ) : (
        <div className='fp-display'>
          <div className='fp-main-heading'>
            Forgot your <br></br> Password?{' '}
          </div>
          <div className='fp-follow-up-text'>
            Enter your email address below and we we'll get you back on track
          </div>
          <form className='fp-form'>
            <input
              className='fp-email'
              placeholder='Enter your e-mail address'
              ref={emailRef}
              value={userEmail as string}
              onChange={updateEmail}
              onKeyPress={checkLoginEnter}></input>
            {error ? <div className='error'>{errorMessage}</div> : ''}
            <button
              className='fp-submit-button'
              onClick={(e: any) => sendForgotPasswordLink(e)}
              disabled={sendingMail}>
              {sendingMail ? 'Sending mail...' : 'Submit'}
            </button>
            <div className='fp-back-to-signin' onClick={() => showLogin()}>
              Back to sign in
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default Forgotpassword;
